var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('div',{staticClass:"main-content"},[_c('div',[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }